var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextSize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 6.5C9.33203 5.72343 9.33203 5.33515 9.4589 5.02886C9.62806 4.62048 9.95251 4.29602 10.3609 4.12687C10.6672 4 11.0555 4 11.832 4H20.1654C20.9419 4 21.3302 4 21.6365 4.12687C22.0449 4.29602 22.3693 4.62048 22.5385 5.02886C22.6654 5.33515 22.6654 5.72343 22.6654 6.5M13.4987 17.3333H18.4987M15.9987 4V17.3333",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 12.418C1.33203 11.8744 1.33203 11.6026 1.42084 11.3882C1.53925 11.1023 1.76637 10.8752 2.05223 10.7568C2.26663 10.668 2.53843 10.668 3.08203 10.668H8.91536C9.45896 10.668 9.73076 10.668 9.94516 10.7568C10.231 10.8752 10.4581 11.1023 10.5766 11.3882C10.6654 11.6026 10.6654 11.8744 10.6654 12.418M4.2487 20.0013H7.7487M5.9987 10.668V20.0013",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSize);
export default __webpack_public_path__ + "static/media/TextSize.4afa1001c2f4907877d98f418234dc21.svg";
export { ForwardRef as ReactComponent };